<template>
  <div>
    <div class="row p-3 pt-0" v-show="loading_bar">
      <v-progress-linear indeterminate color="cyan"></v-progress-linear>
    </div>
    <div class="row">
      <div>
        <div class="card col-md-12">
          <h4 class="card-title">Omisos</h4>
          <div class="card-content form-group" v-if="getKey('permisos').includes(21)">
            <div class="row">
              <div v-if="getKey('permisos').includes(14)" class="col-9">
                <label>Dependencia </label><br>
                <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
                  <el-option v-for="option in dependencias1" :value="option.id" :label="option.valor" :key="option.valor">
                  </el-option>
                </el-select>
              </div>
              <!-- <div class="col-3">
                <label>Año</label><br>
                <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
                  <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
                  </el-option>
                </el-select>
              </div> -->

              <div class="col-3 text-left d-flex align-items-end">
                <button @click="getOmisos" class="btn btn-success btn-wd pull-right" :disabled="loading_bar">
                  {{ loading_bar ? 'Buscando datos' : 'Buscar' }}
                </button>
              </div>
            </div>
          </div>
          <br><br><br>
          <div class="row">
            <div class="col-md-6">
              <export-excel class="btn btn-wd btn-success" :data="list_declarantes" :meta="meta" :fields="cumplidos_campos" worksheet="Cumplidos" :name="nombreC">
                <span class="btn-label">
                  <i class="fa fa-file-excel"></i>
                </span>
                Descargar Reporte
              </export-excel>
            </div>
            <div class="col-md-6">
              <b-form-group>
                <b-input-group>
                  <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <v-data-table :headers="headers" :items="list_declarantes" :items-per-page="5" class="" :search="filter" :fixed-header="true">

                <template v-slot:item.prog="{ item }">


                  <v-progress-circular v-if="item.limite >= 1" :rotate="360" :size="60" :width="5" :value="item.limite" color="teal">
                    {{ item.limite }}

                  </v-progress-circular>

                  <v-progress-circular v-if="item.limite < 1" :rotate="360" :size="60" :width="5" :value="100" color="red">
                    {{ item.limite * -1 }}

                  </v-progress-circular>

                </template>

              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
import moment from 'moment'
import excel from 'vue-excel-export'
import {
  Table,
  TableColumn,
  Select,
  Option
} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(excel)

export default {
  components: {
    StatsCard,
    ChartCard,
    CircleChartCard,
    PPagination
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data () {
    return {
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: ''
      },
      rol: '',
      // periodos: [],
      loading_bar: false,
      dependenciaT: '',
      mostrar: false,
      perPage: 5,
      rows: null,
      currentPage: 1,
      filter: null,
      perPage2: 5,
      rows2: null,
      currentPage2: 1,
      filter2: null,
      list_declarantes: [],
      avance: 0,
      avanced: '',
      totald: '',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      cumplidos_campos: {
        'Tipo': 'tipo',
        'RFC': 'rfc',
        'Nombres': 'nombres',
        'Fecha': 'fecha',
        'Fecha Posesion': 'fecha_posesion',
        'Fecha Termino': 'fecha_termino',
        'Limite': 'limite'
      },
      nombreC: '',
      nombreF: '',
      cumplidos_data: [],
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      fecha: '',
      propsToSearch: ['rfc', 'nombres', 'cargo'],
      propsToSearch2: ['rfc', 'nombres', 'cargo', 'correo1', 'correo2', 'tel1', 'tel2'],
      headers: [{
        text: 'Tipo',
        align: 'center',
        value: 'tipo',
        class: '',
        width: 150
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombres',
        value: 'nombres',
        align: 'left'
      },
      {
        text: 'Fecha Ingreso/Baja',
        value: 'fecha',
        align: 'center'
      },
      {
        text: 'Fecha Limite',
        value: 'fechaLimite',
        align: 'center'
      },
      {
        text: 'Limite',
        value: 'prog',
        align: 'center'
      }
      ]

    }
  },
  computed: {
    to () {
      let highBound = this.from + this.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.perPage * (this.currentPage - 1)
    },
    total () {
      // console.log(this.list_usuarios.length);
      this.rows = this.list_declarantes.length

      return this.list_declarantes.length
    }

  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    checkPermissions () {
      let permiso = [6, 21]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
      if (!this.getKey('permisos').includes(21)) // permiso de declaraciones global
        { this.getOmisos() }
    },
    // getDependencias() {
    //   var v = this;
    //   this.$http.get("cat_ente_publico").then(
    //     response => {
    //       this.dependencias = response.data.entes_publicos;
    //       this.dependencias.push({
    //         'codigo': 'T',
    //         'id': 0,
    //         'valor': 'Todas'
    //       });
    //     },
    //     error => {
    //       this.StepError(error);
    //     }
    //   );
    // },
    // getPeriodos () {
    //   var v = this
    //   this.$http.get('getPeriodos').then(
    //     response => {
    //       this.periodos = response.data.periodos
    //     },
    //     error => {
    //       this.StepError(error)
    //     }
    //   )
    // },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    getOmisos () {
      if (!this.getKey('permisos').includes(21)) // permiso de declaraciones global
        { this.model.dependencia_id = this.getKey('ente_publico_id') }
      if (this.model.dependencia_id >= 0) {
        this.loading_bar = true
        this.$http.post('getOmisos2', this.model).then(
          response => {
            this.list_declarantes = response.data.omisos
            console.log(response.data.id_error)
            this.loading_bar = false
          },
          error => {
            this.StepError(error)
            this.loading_bar = false
          }
        )
      } else {
        this.StepW('Llena todos los campos')
      }
    }
  },
  created () {
    this.checkPermissions()
    // this.getDependencias();
    // this.getPeriodos()
    this.rol = this.getKey('role')
    var myDate = new Date()
    var mes = ('0' + (myDate.getMonth() + 1)).slice(-2)
    var dia = ('0' + myDate.getDate()).slice(-2)
    var anio = myDate.getFullYear()
    this.fecha = dia + '/' + mes + '/' + anio

    this.nombreC = 'Omisos' + this.fecha + '.xls'
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Omisos.vue